import { isPrimaryInsurance } from "./primaryItemScripts";
import { getUMReducedAmountClean, getUMReducedAmountCleanV2 } from "./misc";
function resolveUMPatientAmount(value) {
    if (value == null || value === '') return 0
    const asNumber = Number(`${value}`.replace(/,/g, ''))
    if (!Number.isNaN(asNumber) && Number.isFinite(asNumber)) {
        return asNumber
    }
    return 0
}

export const ascFunctions = {
    calculateTotalFunds: (asc) => {
        // Calculate Liability Funds Available
        const liabilityFunds = asc.liabilityFundsAvailable || 0;
        // Calculate UM Funds Available
        const umFunds = asc.umFundsAvailable || 0;
        // Calculate total of Practice Balances, excluding those with the name 'TransMedic'
        let practiceBalances = 0;
        if (Array.isArray(asc.practiceBalances)) {
            practiceBalances = asc.practiceBalances
                .filter(pb => pb.practiceName !== 'TransMedic')
                .reduce((acc, pb) => acc + (pb.balance || 0), 0);
        }
        // Final calculation
        return liabilityFunds + umFunds - practiceBalances;
    },
    calculateTotalUMFundsAvailable: (activeCase, itemData) => {
        if (activeCase && isPrimaryInsurance(activeCase, 'mp_pip_um')) {
            let primary = isPrimaryInsurance(activeCase, 'mp_pip_um')
    
            if (primary.has_um) {
                if (primary.um_type == 1) { // Reduced
                    return Number(itemData.step_2_funds_available) + getUMReducedAmountClean(isPrimaryInsurance(activeCase, 'liabilities'), primary)
                }
    
                if (primary.um_type == 0) { // Addon
                    const amount = resolveUMPatientAmount(primary.um_policy_limit_patient)
                    return Number(itemData.step_2_funds_available) + amount
                }
            } else {
                return Number(itemData.step_2_funds_available)
            }
        }
    
        return null
    },
    calculateLiabilityFundsAvailablePlusUMFundsAvailable: (activeCase) => {
        if (activeCase && isPrimaryInsurance(activeCase, 'mp_pip_um')) {
            let primary = isPrimaryInsurance(activeCase, 'mp_pip_um')
    
            return getUMReducedAmountCleanV2(isPrimaryInsurance(activeCase, 'liabilities'), primary)
        }
    
        return null
    },
}